<template>
  <div class="condition-container">
    <!-- <ConditionFilter 
      :groupUserFilter="filter"
      filterStyle="trainings"
      :includable_columns="includable_columns" 
      :user_data="additional_user_data"
      :user_count="user_count"
      :options="{timeframeOptions: timeframeOptions, assignTimingType:assignTimingType}"
      :groups="groups"
      :selectedFilter="Array.isArray(selectedFilter) ? selectedFilter : []"
      @filterEvent="saveFilter"
      @viewList="viewUserList"
      /> -->
       <ConditionFilterNew 
      :groupUserFilter="filter"
      ref="ConditionFilter"
      filterStyle="trainings"
      :includable_columns="includable_columns" 
      :user_data="additional_user_data"
      :user_count="user_count"
      :options="{timeframeOptions: timeframeOptions, assignTimingType:assignTimingType}"
      :groups="groups"
      :selectedFilter="Array.isArray(selectedFilter) ? selectedFilter : []"
      @filterEvent="saveFilter"
      @viewList="viewUserList"
      />
      <InvitedUserListModal
        class="embedded-modal"
        v-if="preview.show" 
        :users="preview.users" 
        :item="preview.item"
       />
  </div>
</template>

<script>
import ConditionFilter from "@/components/layout/groups/ConditionFilter.vue";
import ConditionFilterNew from "@/components/layout/groups/filters/ConditionFilterNew.vue";
import InvitedUserListModal from "@/components/layout/trainings/training_users/invitation_list/InvitedUserListModal.vue";

import axios from 'axios'
export default {
    components:{
        ConditionFilter,
        ConditionFilterNew,
        InvitedUserListModal
    },
    props:{
        additional_user_data:Array,
        includable_columns:Array,
        preview: Object,
        selectedFilter: Array | Object,
        user_count: Number,
        groups: Array,
    },
    data(){
        return{
            filter: [],
            timeframeOptions: [
                {
                    id: 0,
                    label: this.toLocal("generic.hours_multiple"),
                    label_short: this.toLocal("generic.hours_short"),
                    value: 3600
                },
                 {
                    id: 1,
                    label: this.toLocal("generic.days_multiple"),
                    label_short: this.toLocal("generic.days_short"),
                    value: 86400
                },
                {
                    id: 2,
                    label: this.toLocal("generic.weeks_multiple"),
                    label_short: this.toLocal("generic.weeks_short"),
                    value: 604800
                },
                {
                    id: 3,
                    label: this.toLocal("generic.months_multiple"),
                    label_short: this.toLocal("generic.months_short"),
                    value: 2592000
                },
                {
                    id: 4,
                    label: this.toLocal("generic.years_multiple"),
                    label_short: this.toLocal("generic.years_short"),
                    value: 31536000
                },
            ],
            assignTimingType: [
                {
                    id: 0,
                    label: this.toLocal("generic.immediately"),
                    value: 'immediately'
                },
                {
                    id: 1,
                    label: 'po',
                    value: 'after'
                },
               
            ]
        }
    },
    mounted(){
    },
    methods:{
      
        saveFilter(filters){
            this.filter = filters
            if(Array.isArray(this.filter)){
                if(!this.filter[0])  {
                    return
                }
                let cols = this.filter[0].cols;
                if(cols.length == 0) {
                    return
                }
                if(cols.length < 3) {
                    return
                }
                this.$emit('filterUsers',this.filter);
            }
        },
        viewUserList(){
            if(Array.isArray(this.filter)){
                if(!this.filter[0])  {
                    return
                }
                let cols = this.filter[0].cols;
                if(cols.length == 0) {
                    return
                }
                if(cols.length < 3) {
                    return
                }
                this.$emit('previewFilter',this.filter);
            }
        }
       
    }
}
</script>

<style lang="scss" scoped>
.condition-container{
    display: flex;
    flex-direction: column;
    height: 100%;
    padding: 16px;
    z-index: 3;
    overflow: auto;
    position: relative;
}
.embedded-modal{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 2;
    background: white;
}
</style>